import { RouteRecordRaw } from "vue-router";
import { userMustBeLoggedIn, userMustHaveApproval } from "../../router/guards";

const routes: RouteRecordRaw[] = [
    {
        path: '/my-portfolios',
        name: 'my-portfolios',
        redirect: { name: 'my-portfolio-listing' },
        component: () => import('./my-portfolio-page.vue'),
        beforeEnter: [userMustBeLoggedIn, userMustHaveApproval],
        children: [
            {
                name: 'my-portfolio-listing',
                path: 'listing',
                component: () => import('./my-portfolio-listing-page.vue'),
                beforeEnter: [userMustBeLoggedIn],
            },
            {
                name: 'portfolio-details',
                path: ':portfolioId/details',
                component: () => import('./my-portfolio-detail-page.vue'),
                beforeEnter: [userMustBeLoggedIn],
                props: true,
                children: [
                    {
                        name: 'portfolio-details-update',
                        path: 'update',
                        component: () => import('./my-portfolio-update-form.vue'),
                        beforeEnter: [userMustBeLoggedIn]
                    },
                    {
                        name: 'portfolio-details-upload-video',
                        path: 'upload-video',
                        component: () => import('./video-trailer-upload-form.vue'),
                        beforeEnter: [userMustBeLoggedIn],
                    }
                ]
            }
        ]
    }
]

export default routes;